import React, { useRef, useEffect } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { useTimeout } from 'utils/components';

const useMediaSlide = (show, onShow, onHide) => {
  const containerRef = useRef(null);
  const mediaRef = useRef(null);
  const prevShowRef = useRef(show);
  
  useEffect(() => {
    if (show !== prevShowRef.current) {
      
      if (show) {
        showSlide();
      } else {
        hideSlide();
      }
      prevShowRef.current = show;
    }
  }, [show]);

  const showSlide = () => {
    const container = containerRef.current;
    if (!container) return;

    onShow?.();
    
    containerRef.current.classList.add('fade-in');
    containerRef.current.classList.remove('hidden', 'fade-out');
  };

  const hideSlide = () => {
    const container = containerRef.current;
    if (!container) return;

    onHide?.();

    container.classList.add('fade-out');
    container.classList.remove('hidden', 'fade-in');
  };

  return {
    containerRef,
    mediaRef
  };
};

export const ImageSlide = ({ show, scene, className }) => {
  const handleShow = () => {
    const media = mediaRef.current;
    if (!media) return;
    
    media.src = "";
    media.src = scene.url;
  };

  const { containerRef, mediaRef } = useMediaSlide(show, handleShow);

  return (
    <div
      className={cx("g-slide image hidden", className)}
      ref={containerRef}>
      <img ref={mediaRef} alt={scene.url} />
    </div>
  );
};

export const VideoSlide = ({ show, scene }) => {

  const { start: resetVideo, cancel: cancelResetVideo } = useTimeout(1000, () => {
    const video = mediaRef.current;
    if (!video) return;
    video.currentTime = 0;
    video.volume = 0;
    video?.pause();
  });

  const handleShow = () => {
    const video = mediaRef.current;
    if (!video) return;

    cancelResetVideo();

    video.pause();
    video.currentTime = 0;
    video.volume = 0;
    video?.play();
  };

  const handleHide = () => {
    resetVideo();
  };

  const handleVideoEnded = () => {
    const video = mediaRef.current;
    if (!video) return;
    
    video.pause();
    video.currentTime = 0;
    requestAnimationFrame(() => {
      video?.play();
    });
  };

  const { containerRef, mediaRef } = useMediaSlide(show, handleShow, handleHide);

  return (
    <div
      className={cx("g-slide image hidden")}
      ref={containerRef}>
      <video 
        ref={mediaRef}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        onEnded={handleVideoEnded}>
        <source src={scene.url} />
      </video>
    </div>
  );
};
